<template>
    <currency-amount-input
        ref="amountInput"
        v-model="line.amount"
        error-string="Beløp må være satt"
        placeholder="Beløp"
        :input-warning="amountNotSet"
        @update-accrual="onUpdateAccrual"
    />
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import {computed} from 'vue'
import CurrencyAmountInput from '@/components/CurrencyAmountInput.vue'
import {AccountPickerOption} from '@/types/AccountPickerOption'
import {useAccounts} from '@/services/account.service'

type AccrualConfig = { account: string, monthCount: number, startMonth: number, startYear: number }

const accountStore = useAccounts()

const line = defineModel<TransactionEntryLine>({required: true})
const emit = defineEmits(['showMoreInputs'])

const amountNotSet = computed(() => {
    return !line.value.amount
})

const onUpdateAccrual = async (accrualConfig: AccrualConfig) => {
    const account: AccountPickerOption | undefined = accountStore.findAccountOptionFrom(accrualConfig.account)
    if (!account) return

    line.value.accrualAccountNo = accrualConfig.account
    line.value.accrualDuration = accrualConfig.monthCount
    line.value.accrualStartMonth = accrualConfig.startMonth + 1
    line.value.accrualStartYear = accrualConfig.startYear

    emit('showMoreInputs', true)
}
</script>

<style scoped>

</style>